import { RadarIcon } from '@solar-icons/react/linear/radar'
import { GraphUpIcon } from '@solar-icons/react/linear/graph-up'
import { UsersGroupRoundedIcon } from '@solar-icons/react/linear/users-group-rounded'
import type { Icon } from '@solar-icons/react/lib/types'

export interface HeroPrompt {
  title: string
  description: string
  query: string
  icon: Icon
}

/**
 * The three cards on the empty-thread landing screen (`ChatHero`). These
 * mirror the query categories the project README lists as the high-value SQL
 * test set (aggregation, ranking, comparison), so the cards double as a quick
 * smoke test of the pipeline.
 */
export const HERO_PROMPTS: HeroPrompt[] = [
  {
    title: 'Rankings',
    description: 'Compare brokers by profit, exposure, or margin',
    query: 'Show top 5 brokers by Net P&L',
    icon: GraphUpIcon,
  },
  {
    title: 'Positions',
    description: "See who's holding open positions right now",
    query: 'How many brokers have open positions?',
    icon: UsersGroupRoundedIcon,
  },
  {
    title: 'Exposure',
    description: "Find who's carrying the most risk",
    query: 'Which broker has the highest exposure?',
    icon: RadarIcon,
  },
]
